import React, { createContext, useReducer, useEffect, useMemo } from 'react';
import { getTenantBalance } from '../api/sportaloka-client';

export const TransactionContext = createContext();

const initialState = {
  balance: 0,
  loading: true,
  error: null
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_BALANCE':
      return {
        ...state,
        balance: action.payload,
        loading: false,
        error: null
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload
      };
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};

export function TransactionProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchBalance = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    try {
      const response = await getTenantBalance();
      dispatch({ type: 'SET_BALANCE', payload: response.data.data.balance });
    } catch (error) {
      dispatch({ type: 'SET_ERROR', payload: 'Gagal mengambil saldo' });
    }
  };

  useEffect(() => {
    fetchBalance();
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      refreshBalance: fetchBalance
    }),
    [state]
  );

  return <TransactionContext.Provider value={value}>{children}</TransactionContext.Provider>;
}
